// extracted by mini-css-extract-plugin
export var menuIcon = "_nw-0";
export var menuIconInline = "_nw-1";